<template>
  <div class="mt-4 flex flex-col">
    <stripe-pricing-table 
      :pricing-table-id="pricingTableId" 
      :publishable-key="publishableKey" 
      :client-reference-id="clientReferenceId" 
      :customer-session-client-secret="customerSessionClientSecret"/>
  </div>
</template>

<script setup lang="ts">

const props = defineProps({
  pricingTableId: {
    type: String,
    required: true
  },
  publishableKey: {
    type: String,
    required: true
  },
  clientReferenceId: {
    type: String,
    required: false
  },
  customerSessionClientSecret: {
    type: String,
    required: false
  }
});

onBeforeMount(() => {
  const stripePricingTableScript = document.createElement('script')
  stripePricingTableScript.setAttribute('src', 'https://js.stripe.com/v3/pricing-table.js')
  document.head.appendChild(stripePricingTableScript)
});

onMounted(async () => {
  // Add any logic that needs to run when the component is mounted
});

</script>

<style scoped>
/* Add any custom styles for the component here */
</style>